import { Components, Inputs } from "@thisgorilla/primate-ds";
import { useContext } from "react";
import { useTheme } from "styled-components";
import { CreatePostModalContext } from "../../..";
import { API_CALLS } from "../../../../../../../../../API/api_calls";
import {
  Divider,
  LabelContainer,
} from "../../../../../../../../../commonStyles";
import { useAppSelector } from "../../../../../../../../../redux";
import { FlexRowEnd } from "../../../../../../../../Common/Styles";
import Input from "../../../../../../../../Input";
import { VideoContainer } from "./style";

const VideoMeta = () => {
  const { typography } = useTheme();
  const { post_id } = useAppSelector((state) => state.posts);
  const { video_id } = useAppSelector((state) => state.postVideo);
  const { setIsVideoOpen, setPostContentOrder, formik } = useContext(
    CreatePostModalContext
  );
  const { values, setFieldValue, setFieldError, validateField } = formik;
  const remainingCharacters = 500 - (values.video_description?.length ?? 0);

  return (
    <VideoContainer>
      <FlexRowEnd>
        <Components.IconButton
          disabled={false}
          iconType="X"
          kind="Secondary"
          size="Small"
          onClick={() => {
            setIsVideoOpen(false);
            API_CALLS.POSTVIDEO.deleteVideoFromAPost({
              post_id,
              video_id,
            });
            setPostContentOrder((prev) =>
              prev.filter((item) => item !== "video")
            );
            const videoFields = ["video_title", "video_description"];
            videoFields.forEach((field) => {
              setFieldValue(field, "");
              setFieldError(field, undefined);
            });
          }}
        />
      </FlexRowEnd>
      <Divider />
      <LabelContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Video Headline"
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
      </LabelContainer>
      <Input
        fieldName="video_title"
        idPrefix="create-video"
        isRequired
        placeholder="Add a headline to your video"
        size="Medium"
      />
      <LabelContainer>
        <Components.Text
          style={{ tokenStyle: typography.Heading.XXS }}
          text="Description"
          fontWeight="font-weight-semibold"
          lineHeight="line-height-50"
        />
      </LabelContainer>
      <Inputs.Textarea
        fieldName="video-description"
        idPrefix="create-video"
        isRequired
        placeholder="Text"
        size="Medium"
        value={values.video_description}
        onChangeHandler={(value) => {
          setFieldValue("video_description", value.slice(0, 500), false).then(
            () => {
              validateField("video_description");
            }
          );
        }}
        helpText={
          remainingCharacters === 0
            ? "Max characters reached"
            : remainingCharacters <= 50
            ? `${remainingCharacters} characters remaining`
            : undefined
        }
      />
    </VideoContainer>
  );
};

export default VideoMeta;
